import {PartialRouting} from '../partial-routing';

export class RoutingUsers extends PartialRouting {
  constructor(base: string = '') {
    super(base);
  }

  byId(id: number | string): string {
    return `${this.base}${id}`;
  }
}
